import { ShieldCheck } from "lucide-react";
import type { ReactNode } from "react";
import { AdminDashboardBlock } from "./blocks/admin-dashboard-block";
import { AuthBlock } from "./blocks/auth-block";
import { DestinationWorkspace } from "./destination-workspace";

export function AuthShell({
  block = "login-03",
  children,
}: {
  block?: "login-03" | "signup-03";
  children: ReactNode;
}) {
  return <AuthBlock block={block}>{children}</AuthBlock>;
}

export function AdminShell() {
  return (
    <DestinationWorkspace>
      <AdminDashboardBlock />
    </DestinationWorkspace>
  );
}

export function SecurityMark() {
  return <ShieldCheck aria-hidden="true" />;
}
